AgrimarketServices.service('userCropCapitalService', ['$http', 'configurationFactory',
    function ($http, configurationFactory) {
        var sendRequest = function (configfile, callback) {
            $http(configfile)
                .success(function (data) {
                    callback(data, null, null, null);
                })
                .error(function (data, status, headers, config) {
                    callback(data, status, headers, config);
                });
        };

        this.GetUserCropCapital = function (callback) {
            var config = {
                method: 'GET',
                url: configurationFactory.Url['Api'] + 'UserCropCapital/GetUserCropCapital',
            };
            sendRequest(config, callback);
        };
    }]);